import React, { useState } from "react";

import { Visible } from "../../../core/components";
import { CarouselGallery, Details, RCProductInsights } from "../../../views/Listing/index";
import BackgroundRemovalButtons from "./BackgroundRemovalButtons";
import "../../../views/Listing/rc-product-view.scss";
import "../../../views/Listing/rc-product-insights.scss";

const Product = ({ user, product, onSelect, onClose, requestType, onProductRefresh }) => {
  const [galleryIndex, setGalleryIndex] = useState(0);

  // Background removal is an RC-internal image-ops tool (server-side u2net on
  // the RC host, no per-tenant quota or billing). Show it to RC master admins
  // only — tenant admins must not be able to spend RC compute from a product
  // preview. `user` is the UserContext user, threaded down by ProductPreview.
  const showBgRemovalButtons =
    user?.is_master_admin && galleryIndex === 0 && product?.id;

  if (!product) {
    return null;
  }

  const canSeePricesInfo =
    user?.is_admin || user?.can_see_market_prices || user?.can_see_trade_prices;

  return (
    <main id="product" className="preview flex-grow-1 rc-product-view">
      <div className="rc-product-hero">
        <CarouselGallery
          images={product.images}
          isProductPreview={true}
          className="rc-product-hero__gallery"
          onSlide={(idx) => setGalleryIndex(idx)}
          topRightOverlay={
            showBgRemovalButtons ? (
              <BackgroundRemovalButtons
                productId={product.id}
                onSuccess={onProductRefresh}
              />
            ) : null
          }
        />
        <Details
          user={user}
          listing={{ ...product, product }}
          onSelectProduct={onSelect}
          onClose={onClose}
          isProductPreview
          hideLowerSeparator={canSeePricesInfo}
          requestType={requestType}
          heroLayout
        />
      </div>

      <Visible when={canSeePricesInfo}>
        <RCProductInsights
          user={user}
          product={product}
          requestType={requestType}
        />
      </Visible>
    </main>
  );
};

export default Product;
